module.exports = __webpack_public_path__ + "img/user_interface_.45894240.svg";